import staffService from "@/services/staff";

export const STAFF_PROFILE_TAB_OPTIONS = {
    profile: "profile",
    edit: "edit",
    time_sheet: "time_sheet"
};

function defaultState() {
    return {
        statusType: {
            label: "All",
            route: "all",
            value: "all"
        },
        roleType: {
            label: "All",
            value: ""
        },
        staffProfileTab: STAFF_PROFILE_TAB_OPTIONS.profile,
        refresh: 0,
        quota: null,
        staff_details: {},
        staff_id: null,
        newDetails: defaultNewStaffDetails(),
        isLoadingDetailsForm: false
    };
}

const state = defaultState();

const getters = {
    status(state) {
        return state.statusType;
    },
    role(state) {
        return state.roleType;
    },
    quota(state) {
        return state.quota;
    },
    staffDetails: state => {
        return state.staff_details;
    },
    staffId: state => {
        return state.staff_id;
    },
    newDetails: state => {
        return state.newDetails;
    },
    staffProfileTab: state => {
        return state.staffProfileTab;
    },
    refresh: state => {
        return state.refresh;
    },
    isLoadingDetailsForm: state => {
        return state.isLoadingDetailsForm;
    }
};

const mutations = {
    setStatus(state, payload) {
        state.statusType = payload;
    },
    setRole(state, payload) {
        state.roleType = payload;
    },
    setQuota(state, payload) {
        state.quota = payload;
    },
    resetState(state) {
        state = defaultState();
    },
    clearNewDetails(state) {
        state.newDetails = defaultNewStaffDetails();
    },
    setStaffDetails(state, payload) {
        state.staff_details = payload;
    },
    setStaffProfileTab(state, payload) {
        state.staffProfileTab = payload;
    },
    setRefresh(state, payload) {
        state.refresh = payload;
    },
    setNewDetails(state, payload) {
        state.newDetails = payload;
    },
    setIsLoadingDetailsForm(state, payload) {
        state.isLoadingDetailsForm = payload;
    }
};

const actions = {
    reset({ commit }) {
        commit("resetState");
    },
    setRole({ commit }, payload) {
        commit("setRole", payload);
    },
    setStatus({ commit }, payload) {
        commit("setStatus", payload);
    },
    setQuota({ commit }, payload) {
        commit("setQuota", payload);
    },
    async saveNewStaff({ state }) {
        const details = state.newDetails;
        const { firstname, lastname, email } = details;

        if (firstname === "") {
            throw new Error("First Name is required");
        }

        if (lastname === "") {
            throw new Error("Last Name is required");
        }

        if (email === "") {
            throw new Error("Email is required");
        }

        return await staffService.saveNewStaff(details);
    },
    async updateStaff({ state }) {
        const details = state.newDetails;
        const { firstname, lastname, email } = details;

        if (firstname === "") {
            throw new Error("First Name is required");
        }

        if (lastname === "") {
            throw new Error("Last Name is required");
        }

        if (email === "") {
            throw new Error("Email is required");
        }

        return await staffService.updateStaff(details);
    },
    setStaffDetails({ commit }, payload) {
        commit("setStaffDetails", payload);
    },
    setStaffProfileTab({ commit }, payload) {
        commit("setStaffProfileTab", payload);
    },
    setRefresh({ commit }, payload) {
        commit("setRefresh", payload);
    }
};

export default {
    namespaced: true,
    // status,
    state,
    mutations,
    actions,
    getters
};

function defaultNewStaffDetails() {
    return {
        firstname: "",
        lastname: "",
        title: "",
        role_id: null,
        is_provider: 0,
        pay_type: 1,
        license: "",
        dea: "",
        //
        email: "",
        home: "",
        home_country_code: "",
        mobile: "",
        mobile_country_code: "",
        address: "",
        zipcode: "",
        city: "",
        state: "",
        country: "",
        //
        restricted_after_office_access: 0,
        timezone: 0,
        production_credit_id: null,
        unassigned: 0, // is for default_task_receiver
        is_whitelist: 0
    };
}
